import React from 'react';
import DetailPage from '../../components/DetailPage';

export default function ManagedPrint() {
  return <DetailPage type="service" id="managed-print" />;
}
